module.exports = __webpack_public_path__ + "img/Updata.5d240d0e.png";